module.exports = __webpack_public_path__ + "images/bc4f7225bccde9eb3ed1084d9c600f8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/bg-dark.jpg
// module id = 1388
// module chunks = 0